var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InputNumber } from "antd";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import { green6, red6 } from "../../assets/variables";
const EditableNumberInput = (_a) => {
    var { value, onSubmitChange, autoFix, max, min } = _a, rest = __rest(_a, ["value", "onSubmitChange", "autoFix", "max", "min"]);
    const [editing, setEditing] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    useEffect(() => {
        setLocalValue(value);
    }, [value]);
    const isValid = useMemo(() => {
        const { required } = rest;
        if ((required && localValue === null) || localValue === undefined) {
            return false;
        }
        if (min !== undefined && Number(localValue) < Number(min)) {
            return false;
        }
        if (max !== undefined && Number(localValue) > Number(max)) {
            return false;
        }
        return true;
    }, [localValue]);
    const onSubmit = () => {
        if (!isValid) {
            if (autoFix) {
                setEditing(false);
                let fixedValue;
                if (localValue === null || localValue === undefined)
                    fixedValue = min || 0;
                if (min !== undefined && Number(localValue) < Number(min)) {
                    fixedValue = min;
                }
                else if (max !== undefined && Number(localValue) > Number(max)) {
                    fixedValue = max;
                }
                setEditing(false);
                setLocalValue(fixedValue);
                onSubmitChange(fixedValue);
            }
            return;
        }
        setEditing(false);
        onSubmitChange(localValue === undefined ? localValue : Number(localValue));
    };
    const onCancel = () => {
        setEditing(false);
        setLocalValue(value);
    };
    const renderedValue = useMemo(() => {
        if (editing)
            return (_jsx(InputNumber, Object.assign({ status: isValid ? "" : "error" }, rest, { autoFocus: true, value: localValue, onChange: (val) => {
                    setLocalValue(val);
                }, onPressEnter: onSubmit })));
        return _jsx("span", { children: localValue });
    }, [editing, localValue, isValid]);
    const buttons = useMemo(() => {
        if (!editing)
            return (_jsx(EditOutlined, { className: "te-text-sm te-cursor-pointer", onClick: () => setEditing(true) }));
        return (_jsxs(_Fragment, { children: [_jsx(CheckOutlined, { style: { color: green6 }, className: `te-text-sm ${isValid ? "te-cursor-pointer" : "!te-cursor-not-allowed"}`, onClick: onSubmit }), _jsx(CloseOutlined, { style: { color: red6 }, className: "te-text-sm te-cursor-pointer", onClick: onCancel })] }));
    }, [editing, localValue, isValid]);
    return (_jsxs("div", { className: "te-flex te-items-center te-gap-x-2 min-h-[30px]", children: [renderedValue, buttons] }));
};
export default EditableNumberInput;
